import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthServiceService } from '../services/auth-service.service';
// import decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class RoleGuardGuard {
  constructor(public auth: AuthServiceService, public router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = localStorage.getItem('Token');
    // const tokenPayload = decode(token);
    // if (!this.auth.isAuthenticated() || tokenPayload.role !== 'Admin') {
    if (!this.auth.isAuthenticated() || !this.auth.isAuthorizedUser(next.data.roles)) {
      this.router.navigate(['/unauthorized']);
      return false;
    }
    return true;
  }

}
